<template>
  <div class="open-answer-number">
    <input 
      type="number" 
      class="form-control mb-2" 
      v-model="userAnswer"
      placeholder="Vul een getal in..."
      @input="updateAnswer"
      step="1"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedAnswer: {
    type: [String, Number, null],
    default: null
  }
});

const emit = defineEmits(['select-answer']);
const userAnswer = ref('');

watch(() => props.selectedAnswer, (newVal) => {
  if (newVal !== null && (typeof newVal === 'string' || typeof newVal === 'number')) {
    userAnswer.value = newVal;
  }
}, { immediate: true });

function updateAnswer() {
  emit('select-answer', userAnswer.value);
}
</script>
